import { render, staticRenderFns } from "./Activity_communication.vue?vue&type=template&id=52a42b9e&style=height%3A100%25"
import script from "./Activity_communication.vue?vue&type=script&lang=js"
export * from "./Activity_communication.vue?vue&type=script&lang=js"
import style0 from "./Activity_communication.vue?vue&type=style&index=0&id=52a42b9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports